export const DEVICE_SUPPORT_MIN_WIDTH_PX = 1024;

export const UNSUPPORTED_DEVICE_MEDIA_QUERY = `(pointer: coarse) and (max-width: ${DEVICE_SUPPORT_MIN_WIDTH_PX - 0.02}px)`;
